<div class="container mt-4">
  <div class="bg-app-bar px-6 h-16 border-b sticky left-0 flex items-center">
    <h2 class="title my-0 ltr:pr-4 rtl:pl-4 ltr:mr-4 rtl:ml-4 ltr:border-r rtl:border-l hidden sm:block flex-none">
      <span>{{"TROPHIES_LIST.TROPHIES" | translate}}</span>
    </h2>
    <div
      class="rounded-full border px-4 max-w-[300px] flex-auto flex items-center border border-gray-300">
      <mat-icon class="icon-sm text-secondary" svgIcon="mat:search"></mat-icon>
      <input [formControl]="searchCtrl"  class="px-4 py-2 border-0 outline-none w-full bg-transparent" placeholder="{{'GLOBAL.SEARCH' | translate}}" type="search" />
    </div>

    <button class="ml-4 flex-none ltr:mr-4 ltr:border-r" color="primary" mat-mini-fab type="button" (click)="search();resetPage()">
      <mat-icon svgIcon="mat:search"></mat-icon>
    </button>
    <button (click)="reload()" class="ml-4 flex-none blue-bottone" color="primary" mat-mini-fab matTooltip="reload" type="button" >
      <mat-icon svgIcon="mat:autorenew"></mat-icon>
    </button>
    <button class="ml-4 flex-none" color="primary" mat-mini-fab type="button" (click)="createTrophy()">
      <mat-icon svgIcon="mat:add"></mat-icon>
    </button>
  </div>

  <table mat-table [dataSource]="dataSource" *ngIf="trophies">
    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef>{{"TROPHIES_LIST.TITLE" | translate}}</th>
      <td mat-cell *matCellDef="let trophy">{{ trophy.i18nTitle[translate.currentLang.toUpperCase()] }}</td>
    </ng-container>
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>{{"TROPHIES_LIST.TYPE" | translate}}</th>
      <td mat-cell *matCellDef="let trophy">{{trophy.type}}</td>
    </ng-container>

    <ng-container matColumnDef="draft">
      <th mat-header-cell *matHeaderCellDef>{{"TROPHIES_LIST.DRAFT" | translate}}</th>
      <td mat-cell *matCellDef="let trophy">{{"TROPHIES_LIST."+ (trophy.draft ? 'YES' : 'NO') | translate}}</td>
    </ng-container>

    <!-- Action Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row" class="w-10 text-secondary" >
        <button (click)="$event.stopPropagation()"
                [matMenuTriggerData]="{ customer: row }"
                [matMenuTriggerFor]="actionsMenu"
                mat-icon-button
                type="button">
          <mat-icon svgIcon="mat:more_horiz"></mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>


  </table>
  <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [length]="lunghezza" (page)="onPageChanged($event)" class="sticky left-0"></mat-paginator>

</div>

<mat-menu #actionsMenu="matMenu" xPosition="before" yPosition="below">
  <ng-template let-customer="customer" matMenuContent>
    <button  mat-menu-item (click)="editTrophy(customer)">
      <mat-icon svgIcon="mat:edit"></mat-icon>
      <span>{{"GLOBAL.EDIT" | translate}}</span>
    </button>
    <button  mat-menu-item (click)="deleteTrophy(customer._id)">
      <mat-icon svgIcon="mat:delete"></mat-icon>
      <span>{{'GLOBAL.DELETE' | translate}}</span>
    </button>
  </ng-template>
</mat-menu>
